module.exports = __webpack_public_path__ + "img/fillcaution.703d6e55.svg";